/**
 * Include Xpresso Client
 *
 */

/* eslint-disable no-undef */
class XpressoClient {
  constructor({
    id,
    baseUrl,
    apiKey,
    pageContainerId,
    exitUrl,
    vendor,
  }) {
    // eslint-disable-next-line camelcase
    const script = document.createElement('script');
    script.async = true;
    script.src = `${baseUrl}/services/sales/funnel/client.js`;
    const firstScriptOnPage = document.getElementsByTagName('script')[0];
    firstScriptOnPage.parentNode.insertBefore(script, firstScriptOnPage);

    script.addEventListener('load', () => {
      const parameters = {
        id,
        baseUrl,
        pageContainerId,
        apiKey,
        exitUrl,
      };

      if (vendor) {
        parameters.vendor = {
          bineos: {
            instance: vendor,
          },
        };
      }
      window.xpresso.funnel.inject(parameters);
    });
  }
}

export default XpressoClient;
